<div *ngIf="!this.loading" class="contentGlobal">
    <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <div>
            <mat-card class="fuse-card-grid-large">
                <mat-card-header>
                    <mat-card-title translate>COMMONS.YOUR_USERS_LIST</mat-card-title>
                </mat-card-header>
                <div style="display: flex; justify-content: space-between">
                    <div class="inputSearchStyle" style="max-width: 800px">
                        <mat-form-field appearance="outline">
                            <mat-label translate>COMMONS.USER_SEARCH</mat-label>
                            <mat-icon matPrefix [inline]="true">search</mat-icon>
                            <input
                                matInput
                                (keyup)="applyFilterSearch($event)"
                                placeholder="{{ 'COMMONS.SEARCH' | translate }}"
                                [(ngModel)]="searchUser"
                                #searchText
                            />
                            <mat-icon matSuffix [inline]="true" (click)="clearUserSearch()" class="pointer">highlight_off</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="this.customerService.codiceTitolare && this.customerService.codiceTitolare.length > 0">
                    <div class="table-style" *ngIf="!noItems">
                        <table mat-table [dataSource]="dataSourceContractsDetails" multiTemplateDataRows matSort>
                            <ng-container matColumnDef="expand">
                                <th mat-header-cell *matHeaderCellDef aria-label="row actions" style="width: 100px">&nbsp;</th>
                                <td mat-cell *matCellDef="let element">
                                    <button
                                        mat-icon-button
                                        aria-label="expand row"
                                        (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()"
                                    >
                                        <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                                        <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="RagioneSocialeCliente">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate>COMMONS.COMPANY_NAME</span></th>
                                <td mat-cell *matCellDef="let row">
                                    <div style="display: flex; flex-direction: row; align-items: center">
                                        <div
                                            class="circleTypeProduct background-greenMagoWeb"
                                            matTooltip="MagoWeb"
                                            matTooltipClass="tooltip-layout"
                                            *ngIf="row.ProductID == 'MW'"
                                        >
                                            {{ row.ProductID }}
                                        </div>
                                        <div
                                            class="circleTypeProduct background-orangeMagoCloud"
                                            matTooltip="MagoCloud"
                                            matTooltipClass="tooltip-layout"
                                            *ngIf="row.ProductID != 'MW'"
                                        >
                                            {{ row.ProductID }}
                                        </div>
                                        <div>
                                            {{ row.RagioneSocialeCliente }}
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="CodiceCliente">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate>COMMONS.USER_CODE</span></th>
                                <td mat-cell *matCellDef="let row">
                                    {{ row.CodiceCliente }}
                                </td>
                            </ng-container>
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                                <td class="td-detail" mat-cell *matCellDef="let row" [attr.colspan]="this.displayedColumns.length">
                                    <div class="element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
                                        <div style="display: flex; flex-direction: column; align-items: stretch; width: 100%">
                                            <div
                                                style="
                                                    padding-left: 0.8rem;
                                                    padding-top: 0.8rem;
                                                    padding-right: 0.8rem;
                                                    padding-bottom: 0rem;
                                                "
                                            >
                                                <h5>
                                                    {{ this.row.RagioneSocialeCliente }} (<mat-label translate>COMMONS.USER_CODE</mat-label
                                                    >:{{ this.row.CodiceCliente }})
                                                </h5>
                                                <div
                                                    style="
                                                        display: flex;
                                                        flex-direction: row;
                                                        justify-content: flex-start;
                                                        margin-top: 0.8rem;
                                                    "
                                                >
                                                    <div style="min-width: 400px">
                                                        <mat-label style="font-weight: bold" translate>USER_FORM.VATNUMBER</mat-label>:
                                                        {{ this.row.PartitaIvaCliente }}
                                                    </div>
                                                    <div>
                                                        <mat-label style="font-weight: bold" translate>USER_FORM.FISCALCODE</mat-label>:
                                                        {{ this.row.CodiceFiscaleCliente }}
                                                    </div>
                                                </div>
                                                <div
                                                    style="
                                                        display: flex;
                                                        flex-direction: row;
                                                        justify-content: flex-start;
                                                        margin-top: 0.8rem;
                                                    "
                                                >
                                                    <div style="min-width: 400px">
                                                        <mat-label style="font-weight: bold" translate>REG_NO</mat-label>:
                                                        {{ this.row.Matricola }}
                                                    </div>
                                                    <div>
                                                        <mat-label style="font-weight: bold" translate>CONTRACT_NUMBER</mat-label>:
                                                        {{ this.row.NumeroContratto }}
                                                    </div>
                                                </div>
                                                <div
                                                    style="
                                                        display: flex;
                                                        flex-direction: row;
                                                        justify-content: flex-start;
                                                        margin-top: 0.8rem;
                                                    "
                                                >
                                                    <div style="min-width: 400px">
                                                        <mat-label style="font-weight: bold" translate>COMMONS.CONTRACT_DATE</mat-label>:
                                                        {{ this.row.DataContratto }}
                                                    </div>
                                                    <div>
                                                        <mat-label style="font-weight: bold" translate>COMMONS.SUBSCRIPTION_KEY</mat-label>:
                                                        {{ this.row.SubscriptionKey }}
                                                    </div>
                                                </div>
                                            </div>


                                            <div
                                                style="
                                                    padding-left: 0.8rem;
                                                    padding-top: 0rem;
                                                    padding-right: 0.8rem;
                                                    padding-bottom: 0.1rem;
                                                "
                                                *ngIf="row.CodiceCliente!=''"
                                            >
                                                <ms-instances-selection
                                                    *ngIf="
                                                        this.isAllowedToMW_MultiInstances(this.row.ProductID) &&
                                                        !this.storeRoleService.IsInternal &&
                                                        row.SubscriptionKey == ''
                                                    "
                                                    [productID]="this.row.ProductID"
                                                    (instanceSelectedDescri)="selectedInstanceDescri($event)"
                                                    (instanceSelectedValue)="selectedInstanceValue($event)"
                                                ></ms-instances-selection>

                                                <button
                                                    *ngIf="row.SubscriptionKey == ''"
                                                    mat-raised-button
                                                    (click)="SubscriptionActivation(row)"
                                                    color="primary"
                                                >
                                                <span translate>COMMONS.ACTIVATE</span>

                                                </button>
                                            </div>
                                            <div
                                            style="
                                                padding-left: 0.8rem;
                                                padding-top: 0rem;
                                                padding-right: 0.8rem;
                                                padding-bottom: 0.1rem;
                                            "
                                            *ngIf="row.CodiceCliente==''"
                                        >
                                        <div class="message-box warning">
                                          <mat-label translate>COMMONS.USER_WITHOUT_CONTRACT</mat-label>
                                      </div>
                                      </div>
                                            <div
                                                *ngIf="row.SubscriptionKey != ''"
                                                style="
                                                    background-color: white;
                                                    padding-left: 0.8rem;
                                                    padding-top: 0.8rem;
                                                    padding-right: 0.8rem;
                                                    padding-bottom: 0rem;
                                                    margin: 1rem;
                                                "
                                            >
                                                <ms-multicompany-section [currentRow]="row"></ms-multicompany-section>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: displayedColumns"
                                class="element-row"
                                [class.expanded-row]="expandedElement === row"
                                (click)="setParameters(row)"
                            ></tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
                        </table>
                        <mat-paginator #resellerpaginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
                    </div>
                    <div class="message-box warning" *ngIf="noItems">
                        <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>
<div *ngIf="this.loading">
    <tb-loading></tb-loading>
</div>
